export const SCROLL_TO_MESSAGE_BANNER = 'checkout/contacts/SCROLL_TO_MESSAGE_BANNER';
export const scrollToMessageBanner = () => ({
  type: SCROLL_TO_MESSAGE_BANNER,
});
